var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { Box, CircularProgress, Dialog, DialogContent, DialogTitle, Stack, TextField, Typography, } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CustomButton from '../../../components/buttonComponent/CustomButton';
import { dynamicFieldSx, WIZARD_COLORS } from '../../../components/FormComponents/dynamicForm';
import { decodeVin } from '../asset_lookup_service';
import { formatVinInput, VIN_LENGTH, VIN_MIN_LOOKUP_LENGTH, } from '../config/create_application_schema';
var PROMPT_TEXT = 'Search Equipment details by Providing VIN number below';
var VIN_PLACEHOLDER = 'Enter Vin (Ex: 1HGBH41JXMN109186)';
var NOT_FOUND = '-';
var VinLookupDialog = function (_a) {
    var open = _a.open, onApply = _a.onApply, onClose = _a.onClose;
    var _b = React.useState(''), vin = _b[0], setVin = _b[1];
    var _c = React.useState(''), errorMessage = _c[0], setErrorMessage = _c[1];
    var _d = React.useState(false), isDecoding = _d[0], setIsDecoding = _d[1];
    var _e = React.useState(null), details = _e[0], setDetails = _e[1];
    var _f = React.useState({}), decodedValues = _f[0], setDecodedValues = _f[1];
    var clearResult = React.useCallback(function () {
        setDetails(null);
        setDecodedValues({});
        setErrorMessage('');
    }, []);
    var decodeRequestIdRef = React.useRef(0);
    React.useEffect(function () {
        if (open) {
            setVin('');
            setIsDecoding(false);
            clearResult();
            decodeRequestIdRef.current += 1;
        }
    }, [clearResult, open]);
    var handleChange = React.useCallback(function (event) {
        setVin(formatVinInput(event.target.value));
        clearResult();
    }, [clearResult]);
    var isDecodable = vin.length >= VIN_MIN_LOOKUP_LENGTH;
    var handleDecode = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var requestId, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isDecodable || isDecoding) {
                        return [2];
                    }
                    requestId = (decodeRequestIdRef.current += 1);
                    setIsDecoding(true);
                    clearResult();
                    return [4, decodeVin(vin)];
                case 1:
                    result = _a.sent();
                    if (decodeRequestIdRef.current !== requestId) {
                        return [2];
                    }
                    setIsDecoding(false);
                    if (result.errorMessage || !result.details) {
                        setErrorMessage(result.errorMessage);
                        return [2];
                    }
                    setDetails(result.details);
                    setDecodedValues(result.values);
                    return [2];
            }
        });
    }); }, [clearResult, isDecodable, isDecoding, vin]);
    var handleKeyDown = React.useCallback(function (event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            handleDecode();
        }
    }, [handleDecode]);
    var handleApply = React.useCallback(function () {
        onApply(decodedValues);
        onClose();
    }, [decodedValues, onApply, onClose]);
    var rows = React.useMemo(function () { return [
        { label: 'Equipment Manufacturer', value: details === null || details === void 0 ? void 0 : details.manufacturer },
        { label: 'Model', value: details === null || details === void 0 ? void 0 : details.model },
        { label: 'Year', value: details === null || details === void 0 ? void 0 : details.year },
    ]; }, [details]);
    return (React.createElement(Dialog, { open: open, onClose: onClose, fullWidth: true, maxWidth: "sm", "aria-labelledby": "vin-lookup-title", PaperProps: { sx: { borderRadius: '12px' } } },
        React.createElement(DialogTitle, { id: "vin-lookup-title", sx: { fontSize: 16, fontWeight: 600, color: WIZARD_COLORS.ink } }, "Vehicle Details"),
        React.createElement(DialogContent, null,
            React.createElement(Typography, { sx: { fontSize: 13, color: WIZARD_COLORS.body, mb: 1.5 } }, PROMPT_TEXT),
            React.createElement(Stack, { direction: "row", alignItems: "flex-start", gap: 1.5 },
                React.createElement(TextField, { fullWidth: true, size: "small", name: "vinLookup", value: vin, placeholder: VIN_PLACEHOLDER, disabled: isDecoding, onChange: handleChange, onKeyDown: handleKeyDown, inputProps: { maxLength: VIN_LENGTH, 'aria-label': 'VIN' }, sx: dynamicFieldSx }),
                React.createElement(CustomButton, { variant: "contained", MDButton: true, fullWidth: false, bgColor: WIZARD_COLORS.ink, disabled: !isDecodable || isDecoding, onClick: handleDecode, startIcon: isDecoding ? (React.createElement(CircularProgress, { size: 14, sx: { color: 'inherit' } })) : (React.createElement(SearchIcon, { sx: { fontSize: 16 } })) }, "Decode")),
            Boolean(errorMessage) && (React.createElement(Typography, { sx: { mt: 1.5, fontSize: 13, color: WIZARD_COLORS.error } }, errorMessage)),
            Boolean(details) && (React.createElement(Box, { sx: {
                    mt: 2,
                    border: "1px solid ".concat(WIZARD_COLORS.border),
                    borderRadius: '8px',
                    px: 1,
                } }, rows.map(function (row, rowIndex) { return (React.createElement(Box, { key: row.label, sx: {
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                    borderBottom: rowIndex === rows.length - 1
                        ? 'none'
                        : "1px solid ".concat(WIZARD_COLORS.sectionBorder),
                } },
                React.createElement(Typography, { sx: {
                        py: 1.25,
                        px: 2,
                        fontSize: 14,
                        color: WIZARD_COLORS.body,
                    } }, row.label),
                React.createElement(Typography, { sx: {
                        py: 1.25,
                        px: 2,
                        fontSize: 14,
                        fontWeight: 600,
                        color: WIZARD_COLORS.ink,
                    } }, row.value || NOT_FOUND))); })))),
        React.createElement(Stack, { direction: "row", justifyContent: "flex-end", gap: 2, sx: { p: 2 } },
            React.createElement(CustomButton, { variant: "secondary", MDButton: true, fullWidth: false, onClick: onClose }, "Cancel"),
            Boolean(details) && (React.createElement(CustomButton, { variant: "contained", MDButton: true, fullWidth: false, bgColor: WIZARD_COLORS.ink, onClick: handleApply }, "Apply to form")))));
};
export default React.memo(VinLookupDialog);
